import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { graphql } from "gatsby";
import Layout from "../components/Layout";
import Content, { HTMLContent } from "../components/Content";
import ApplicationForm from "../components/ApplicationForm";
import { getData } from "../helper/helper";
import OurTeam from "../components/OurTeam";
import PreviewCompatibleImage from "../components/PreviewCompatibleImage";

// eslint-disable-next-line
export const TeamTemplate = ({
  content,
  contentComponent,
  name,
  locale,
  expertise,
  image,
  description,
  helmet,
}) => {
  const PostContent = contentComponent || Content;
  const team = getData(locale).teamPage;

  return (
    <section className="subPage ">
      {helmet || ""}
      <div className="profile">
        <div className="container">
          <div className="res">
            <PreviewCompatibleImage imageInfo={{ image, alt: name }} />
          </div>
          <div className="titles">
            <h1>{name}</h1>
            <h3>{expertise}</h3>
            <p>{description}</p>
          </div>
        </div>
      </div>
      <div className="container content">
        <div className="main">
          <div className="content">
            <PostContent content={content} />
          </div>
        </div>
        <div className="aside">
          <div className="requestBook">
            <ApplicationForm from={name} />
          </div>
        </div>
      </div>

      <div className="relatedPosts">
        <h5>{team.title}</h5>
        <div className="container services teamwraps">
          <OurTeam locale={locale} />
        </div>
      </div>
    </section>
  );
};

TeamTemplate.propTypes = {
  content: PropTypes.node.isRequired,
  contentComponent: PropTypes.func,
  name: PropTypes.string,
  locale: PropTypes.string,
  description: PropTypes.string,
  expertise: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  helmet: PropTypes.object,
};

const TeamPost = ({ data }) => {
  const { markdownRemark: post } = data;

  return (
    <Layout locale={post.frontmatter.locale}>
      <TeamTemplate
        content={post.html}
        contentComponent={HTMLContent}
        description={post.frontmatter.description}
        helmet={
          <Helmet>
            <title>{`${post.frontmatter.name}`}</title>
            <meta
              name="description"
              content={`${post.frontmatter.description}`}
            />
          </Helmet>
        }
        name={post.frontmatter.name}
        image={post.frontmatter.image}
        expertise={post.frontmatter.expertise}
        locale={post.frontmatter.locale}
      />
    </Layout>
  );
};

TeamPost.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
};

export default TeamPost;

export const pageQuery = graphql`
  query TeamPostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        name
        description
        locale
        expertise
        image {
          childImageSharp {
            fluid(maxWidth: 200, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;
